"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2170],{

/***/ 22170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5a2 2 0 11-4 0 2 2 0 014 0zm-2 2c-5 0-9 4-9 9 0 .6.4 1 1 1h16c.6 0 1-.4 1-1 0-5-4-9-9-9zm6.9 8c-.5-3.4-3.4-6-6.9-6-3.5 0-6.4 2.6-6.9 6h13.8zM4 19c-.6 0-1 .4-1 1s.4 1 1 1h16c.6 0 1-.4 1-1s-.4-1-1-1H4zm9-8.1c.3-.5.9-.7 1.4-.4.9.5 1.7 1.1 2.5 1.9.4.4.3 1-.1 1.4-.2.1-.5.2-.7.2-.3 0-.6-.1-.8-.3-.6-.6-1.2-1.1-1.9-1.5-.5-.2-.7-.9-.4-1.3z"
}), "Recepcionist"));


/***/ })

}]);